import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import '../scss/task.scss'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form'
import { useLocation, useNavigate, useParams } from "react-router";
import { PROJECT_MANAGEMENT, VENDOR, VENDOR_ORDERS } from "../../../constants/route-paths";
import idx from "idx";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getPOList, getPurchaseOrder, updatePOStock } from "../../../actions/project-management.action";
import { useSelector } from "react-redux";
import { getProjectData } from "../utils/get-project";
import _ from "lodash";
import { resolveProjectType } from "../utils/resolve-project-type";
import SelectInput from "../../../components/inputs/select";

import { warningSnackBar } from "../../../actions/common.action";
import CustomInput from "../../../components/inputs/new-input";
import { numberFormat } from "../../../util/currency-formatter";
import { parseNumericValue, isInlineItem, INLINE_CATALOG_DISPLAY_NAME } from "../../../util/common";
import { TaskType } from "../../../util/enums";
import { VENDOR_STATUS, VENDOR_TAB, VENDOR_URL_PARAM } from "../../../constants/vendor.contant";

export default function ReceiceStock({ writePermission, ...props }) {

  const [state, setState] = useState({
    selectedPO: false,
    items: [],
    vendorName: '',
    PoNO: 0,
    procurementCode: '',
    selectedStock: [],
  })
  const [fields, setFields] = useState({
    po: {
      name: "po",
      label: "Select PO",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [],
      dataCy: "select-po",
      validation: ["required"],
    },
    location: {
      name: "location",
      label: "Location",
      type: "select",
      touched: false,
      error: false,
      valid: true,
      value: "",
      items: [
        { key: "WareHouse", value: "WAREHOUSE" },
        { key: "Site", value: "SITE" },
      ],
      dataCy: "select-location",
      validation: [""],
    },

  })
  const [isReceiveAll, setIsReceiveAll] = useState(false);
  const { vendorId, poId, projectId } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const pathName = idx(location, (_) => _.pathname);

  const dispatch = useDispatch()
  const navigate = useNavigate();

  const { projectDetail = {}, user, project: projectState } = useSelector(state => state)
  let projectType = resolveProjectType(searchParams.get("project-type")
    || idx(projectDetail, _ => _.project.projectDataType)
    || idx(projectDetail, _ => _.project.res.projectType), projectState);
  const isReturnStock = location.pathname.includes("return-stock") ? true : false;

  useEffect(() => {
    if (!idx(projectDetail, _ => _.project.res))
      getProjectData({ projectId, dispatch })

    if (vendorId && poId) {
      setState(prev => ({
        ...prev,
        selectedPO: true
      }));
    }

    initLoad();
  }, []);

  const initLoad = () => {
    dispatch(getPOList({ projectId, vendorType: "Supplier", poId }))
      .then(({ list: poList }) => {
        if (poId) {
          poList.forEach((po) => {
            if (po.u_id == poId) {
              setState(prev => ({
                ...prev,
                PoNO: po.id,
                procurementCode: po.f_id,
              }));
            }
          });
          changePOType({ target: { name: "po", value: poId } });
        }

        const vendors = [];
        Array.isArray(poList) &&
          poList.forEach(({ vendor }) => {
            const business_name = idx(vendor, (_) => _.business_name) || "";
            const id = idx(vendor, (_) => _.id) || null;
            const isSelected = vendors.find(({ value }) => value === id);
            if (!isSelected && id) {
              vendors.push({
                key: business_name,
                value: id,
              });
            }
          });
        let vendorName = idx(vendors.find((v) => v.value === vendorId), (_) => _.key) || "";
        setState(prev => ({
          ...prev,
          vendorName,
        }));
      });
    setState(prev => ({
      ...prev,
      userName: [idx(user, _ => _.userData.firstName), idx(user, _ => _.userData.lastName)].filter(item => item).join(' '),
    }));
  }


  const changePOType = async (e) => {
    const value = e.target.value;
    inputChangeHandler(e);
    const query = `?poId=${value}`;
    const po = await dispatch(getPurchaseOrder(query));
    const items = idx(po, (_) => _.items) || [];
    Array.isArray(items) &&
      items.forEach((item) => {
        const invoices = [{ key: "None", value: null }];
        Array.isArray(item.invoices) &&
          item.invoices.forEach((invoice) => {
            invoices.push({
              key: invoice.invoiceNo,
              value: invoice.invoiceId,
              ...invoice,
            });
          });
        item.invoices = invoices;
        item.selectedInvoice = null;
        item.invoicedQty = 0;
      });
    setState(prev => ({
      ...prev,
      items
    }));
    if (po.deliveryOption === 'PICKUP') return
    let poLocation = ''
    if (po.deliveryOption === 'OFFICE') poLocation = 'WAREHOUSE'
    else poLocation = po.deliveryOption
    setFields(prev => ({
      ...prev,
      location: { ...prev.location, value: poLocation }
    }))
  };

  const inputChangeHandler = (e) => {
    fields[e.target.name].value = e.target.value;
    fields[e.target.name].touched = true;
    const { error, valid } = handleValidation(e.target, fields[e.target.name].validation);
    fields[e.target.name].error = error;
    fields[e.target.name].valid = valid;
    setFields(prev => ({
      ...prev,
      ...fields,
    }));
  };

  const handleValidation = ({ name, type, value }, validation) => {
    let error = false;
    let valid = true;
    if (
      validation.includes("required") && (value === undefined || (!_.isBoolean(value) && !_.isNumber(value) && value.trim() === ""))
    ) {
      return { error: "This Field is Required", valid: false };
    }
    return { error, valid };
  };



  const invoiceChangeHandler = (value, index) => {
    const items = _.cloneDeep(state.items);
    const item = _.cloneDeep(items[index]);
    if (value != null) {
      const invoice = item.invoices.find((inv) => inv.value === value);
      if (invoice) {
        item.invoicedQty = invoice.invoicedQty;
      }
    }
    item.selectedInvoice = value;
    items[index] = _.cloneDeep(item);
    setState(prev => ({
      ...prev,
      items
    }));
  };

  const stockChangeHandler = (e, index) => {
    const items = state.items;
    const item = items[index];
    let enteredValue = parseFloat(e.target.value) || 0;
    if (enteredValue < 0) {
      return;
    }
    let allowedQty = parseFloat(item.qty) - parseFloat(item.receivedQty);
    if (enteredValue > allowedQty) {
      return
    } else {
      items[index].error = false;
    }
    items[index].newStock = e.target.value;

    const stockIndex = findSelectedStock(state.selectedStock, item.id, item.taskId, index);
    if (stockIndex !== -1 && (item.qty - item.receivedQty) != item.newStock) {
      state.selectedStock.splice(stockIndex, 1);
      items[index].error = "";
    }
    if ((item.qty - item.receivedQty) == item.newStock) {
      state.selectedStock.push({ qty: item.newStock, id: item.id, taskId: item.taskId })
    }
    const allChecked = state.items.every((item, index) => findSelectedStock(state.selectedStock, item.id, item.taskId, index) !== -1);
    setIsReceiveAll(allChecked)
    setState(prev => ({
      ...prev,
      items
    }));
  };

  const returnStockChangeHandler = (e, index) => {
    const items = state.items;
    const item = _.cloneDeep(items[index]);
    let enteredValue = parseFloat(e.target.value) || 0;
    if (enteredValue < 0) {
      return;
    }
    if (item.selectedInvoice === null) {
      let receivedQty = parseFloat(item.receivedQty || 0);
      if (enteredValue > receivedQty) {
        item.error = "You can not enter more than received qty";
      } else {
        item.error = false;
      }
    } else {
      // if a invoice is selected then invoiced qty will be considered for validation
      let invoicedQty = parseFloat(item.invoicedQty || 0);
      if (enteredValue > invoicedQty) {
        item.error = "You can not enter more than invoiced qty";
      } else {
        item.error = false;
      }
    }

    item.returnStock = e.target.value;
    items[index] = _.cloneDeep(item);
    setState(prev => ({
      ...prev,
      items
    }));
  };

  const handleReceiveAllChange = (checked) => {
    state.items.map((item, index) => {
      const allowedQty = parseFloat(item.qty) - parseFloat(item.receivedQty);
      handleCheckboxClick(allowedQty, checked, item.id, item.taskId, index);
    });
  };
  const findSelectedStock = (stock, id, taskId, rowIndex) => {
    return stock.findIndex(t => t.id === id && t.taskId === taskId && t.rowIndex === rowIndex);
  }

  const handleCheckboxClick = (qty, checked, id, taskId, rowIndex) => {
    let { selectedStock = [] } = state, alreadySelected = -1;
    if (checked) {
      if (selectedStock.length) alreadySelected = findSelectedStock(selectedStock, id, taskId, rowIndex)
      if (alreadySelected === -1) selectedStock.push({ qty, id, taskId, rowIndex })
      setState(prevState => ({
        ...prevState,
        items: prevState.items.map((item, index) =>
          index === rowIndex && item.id === id && item.taskId === taskId && qty ? { ...item, newStock: qty } : item
        )
      }));
    } else {
      const index = findSelectedStock(selectedStock, id, taskId, rowIndex);
      selectedStock.splice(index, 1);
      setState(prevState => ({
        ...prevState,
        items: prevState.items.map((item, index) =>
          index === rowIndex && item.id === id && item.taskId === taskId ? { ...item, newStock: '', error: '' } : item
        )
      }));
    }
    const allChecked = state.items.every((item, index) =>
      findSelectedStock(state.selectedStock, item.id, item.taskId, index) !== -1
    );
    setIsReceiveAll(allChecked);
    setState(prev => ({
      ...prev,
      selectedStock
    }));
  };

  const submitForm = () => {
    const {
      userName,
      items,
      selectedStock,
    } = state;
    let isFormValid = true;

    for (let key in fields) {
      const { error, valid } = handleValidation(fields[key], fields[key].validation);
      fields[key].touched = true;
      fields[key].valid = valid;
      fields[key].error = error;
      isFormValid = isFormValid && valid;
    }
    items && items.forEach((item) => {
      if (item.error) {
        isFormValid = false;
      }
    });

    if (!fields.location.value && !isReturnStock) {
      dispatch(warningSnackBar("Please Select Delivery Location"));
      return;
    }



    if (!isFormValid) {
      setFields(prev => ({
        ...prev,
        ...fields
      }));
    } else {
      const data = {
        items,
        // allocationLocation: fields.location.value,
        poId: "" + poId,
        transactionType: isReturnStock ? "RETURNED" : "RECEIVED",
      };
      if (fields.location.value) data.allocationLocation = fields.location.value
      if (fields.location.value === "SITE") {
        data.allocateToName = idx(projectDetail, _ => _.project.projectName);
        data.allocateToId = projectId;
      } else {
        data.allocateToName = userName;
        data.allocateToId = idx(user, _ => _.userData.id);
      }

      items.forEach((item, index) => {
        const newStock = parseFloat(item.newStock || 0);
        const receivedQty = parseFloat(item.receivedQty || 0);
        if (isReturnStock) {
          const returnStock = parseFloat(item.returnStock || 0);
          item.receivedQty = receivedQty - returnStock;
          if (item.selectedInvoice !== null) {
            item.containInvoicedReturn = true;
            item.returnedQty = returnStock;
            const invoice = item.invoices.find(
              (inv) => inv.value === item.selectedInvoice
            );
            item.taskId = invoice.taskId;
            item.invoiceId = invoice.invoiceId;

            item.amountPaid =
              parseFloat(invoice.amountPaid || 0) -
              parseFloat(item.returnStock || 0) * parseFloat(item.cost || 0);
          }
        } else {
          item.receivedQty = newStock + receivedQty;
        }
        item.taskType = item.taskType || TaskType.TASK;
        item.name = item.item;
        item.costPerItem = item.cost;
        delete item.invoices;
        if (selectedStock.findIndex((t) => t.id === item.id && index === t.rowIndex) !== -1) {
          item.receivedQty += (parseFloat(item.qty) || 0) - (parseFloat(item.receivedQty) || 0);
        }
      });
      data.items = items;
      dispatch(updatePOStock(data, poId)).then((res) => {
        viewProject();
      }).catch(e => console.log(e));
    }
  };

  const viewProject = () => {
    // Check if we have return tab parameters (coming from vendor page)
    const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB);
    const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB) || VENDOR_STATUS.ACTIVE;

    if (returnTab) {
      // Redirect back to vendor orders page with the correct tab
      navigate(`/${VENDOR}/${VENDOR_ORDERS}?${VENDOR_URL_PARAM.TAB}=${returnTab}${returnSubTab ? `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}` : ''}`);
    } else if (vendorId && poId) {
      navigate(`/${PROJECT_MANAGEMENT}/purchase-order/${projectId}`);
    } else {
      navigate(`/${PROJECT_MANAGEMENT}/view/${projectId}`);
    }
  }
  const viewProjectList = () => navigate(`/projects?project-type=${projectType || 'MAJOR'}`)
  // const viewPO = () => navigate(`view/${poId}`);
  // const editPO = () => navigate(`edit/${poId}`);
  // const createPO = () => navigate(`create-purchase-order`);
  // const receiveStock = () => navigate(`/${PROJECT_MANAGEMENT}/receive-stock/${projectId}/${vendorId}/${poId}`);
  // const returnStock = () => navigate(`/${PROJECT_MANAGEMENT}/return-stock/${projectId}/${vendorId}/${poId}`);
  // const viewInvoices = () => navigate(`/${VENDOR_PAYMENT}?project=${projectId}&poId=${poId}`);

  const getQuantityLeft = (item) => {
    const qtyLeft = (Number(item.qty) || 0) - (Number(item.receivedQty) || 0) - Number(item.newStock || 0)
    return parseNumericValue(numberFormat(qtyLeft, true));
  }

  const getQtyReceive = (item) => {
    const qtyToReceive = (parseFloat(item.qty) || 0) - (parseFloat(item.receivedQty) || 0)
    return parseNumericValue(numberFormat(qtyToReceive, true));
  }

  return (
    <>
      <div className="purchase-order-block" data-cy="receive-stock">

        <h2 className="content-heading text-uppercase">{isReturnStock ? "Return" : "Receive"} Stock</h2>
        <div className="col-12 breadcrumb-block p-0">
          <Breadcrumb>
            <Breadcrumb.Item onClick={viewProjectList}>PROJECTS</Breadcrumb.Item>
            <Breadcrumb.Item onClick={viewProject}>{idx(projectDetail, _ => _.project.projectName)}</Breadcrumb.Item>
            <Breadcrumb.Item active>{isReturnStock ? "Return" : "Receive"} Stock</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="row">
          <div className="col-lg-4 mt-3">
            <div className="view-block" data-cy="vendor-name">
              <label className="input-label">{state.selectedPO ? "Vendor" : "Select Vendor"}</label>
              <p>{state.vendorName}</p>
            </div>
          </div>
          <div className="col-lg-4 mt-3">
            {state.selectedPO ? (
              <div className="view-block" data-cy="po-no">
                <label className="input-label">{state.selectedPO ? "PO" : "Select PO"}</label>
                <p>
                  {/* procurementCode is the PO number with project prefix and Suffix if null then default to po Number*/}
                  <b>{state.procurementCode || state.PoNO}</b>
                </p>
              </div>
            ) : (
              <SelectInput
                onChange={(e) => changePOType(e)}
                {...fields.po}
                label={'Select PO'}
                disable={poId}
              />
            )}
          </div>
          {!isReturnStock && <div className="col-lg-4 mt-3">
            <SelectInput
              onChange={(e) => inputChangeHandler(e)}
              {...fields.location}
              label={'Location'}
            />
          </div>}

          <div className="col-12">
            <div className="material-list-block mt-4">
              <div className="table-responsive">
                <Table bordered className="table-create table-material table-material-ch" data-cy="material-list">
                  <thead>
                    <tr>
                      <th className="w-auto" data-cy="task-name-header">Task Name</th>
                      <th className="w-auto" data-cy="item-header">Item</th>
                      <th data-cy="catalog-header">Catalog</th>
                      <th data-cy="ordered-quantity-header">Ordered Quantity</th>
                      <th data-cy="already-received-header">Already Received</th>
                      <th data-cy="quantity-left-header">Quantity Left</th>
                      {isReturnStock && (<th data-cy="select-invoice-header">Select Invoice</th>)}
                      <th data-cy="quantity-to-receive-header">{isReturnStock ? "Enter Return Stock" : "Quantity To Receive"}</th>
                      {!isReturnStock && <th data-cy="receive-all-header">
                        <div class="table-checkbox">
                          <Form.Check
                            id={"receiveAll"}
                            type={'checkbox'}
                            checked={isReceiveAll}
                            onChange={(e) => {
                              setIsReceiveAll(e.target.checked);
                              handleReceiveAllChange(e.target.checked);
                            }}
                            data-cy="receive-all"
                          />
                          <Form.Check.Label for={"receiveAll"}>Receive All</Form.Check.Label>
                        </div>
                      </th>}
                    </tr>
                  </thead>
                  <tbody>
                    {state.items.map((item, index) => {
                      return (
                        <tr key={index} data-cy="material-list-item">
                          <td data-cy="task-name">{item.taskName}</td>
                          <td data-cy="item">{item.item}</td>
                          <td data-cy="catalog">{isInlineItem(item) ? INLINE_CATALOG_DISPLAY_NAME : item.category}</td>
                          <td data-cy="ordered-quantity">{parseNumericValue(numberFormat(item.qty, true)) || 0}</td>
                          <td data-cy="already-received">{parseNumericValue(numberFormat(item.receivedQty, true)) || 0}</td>
                          <td data-cy="quantity-left"> {getQuantityLeft(item) || 0}</td>
                          {isReturnStock && (<td>
                            <SelectInput
                              className="input-block-sm"
                              items={item.invoices}
                              value={item.selectedInvoice}
                              onChange={(e) => invoiceChangeHandler(e.target.value, index)}
                              data-cy="select-invoice"
                            />
                          </td>)}
                          <td>
                            <CustomInput
                              className="input-block-sm"
                              data-cy="return-stock-input"
                              value={isReturnStock ? item.returnStock : item.newStock}
                              lable="Stock"
                              type="number"
                              valid={!item.error}
                              error={item.error}
                              disabled={state.selectedStock.find(_ => _.id === item.id) || false}
                              onChange={(e) => {
                                if (isReturnStock) {
                                  returnStockChangeHandler(e, index)
                                } else {
                                  stockChangeHandler(e, index)
                                }
                              }}
                            />
                          </td>
                          {!isReturnStock && <td>
                            {
                              (parseFloat(item.qty) || 0) - (parseFloat(item.receivedQty) || 0) != 0 ?
                                (
                                  <div className="table-checkbox">
                                    <Form.Check
                                      type={'checkbox'}
                                      data-cy="receive"
                                      checked={findSelectedStock(state.selectedStock, item.id, item.taskId, index) !== -1 ? true : false}
                                      onChange={(e) =>
                                        handleCheckboxClick(getQtyReceive(item), e.target.checked, item.id, item.taskId, index)
                                      }
                                    />
                                  </div>
                                )
                                : 'Received'
                            }
                          </td>}
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>

            </div>
          </div>
        </div>

        <div className="col-12 d-flex mt-3 justify-content-end">
          <Button type="submit" className="me-3 secondarybtn" onClick={() => submitForm()} data-cy="save-button">SAVE</Button>
          <Button type="submit" className="secondarybtn cancelbtn" onClick={() => viewProject()} data-cy="cancel-button">CANCEL</Button>
        </div>

      </div>
    </>
  )

}
